export const scrollSnapTop = function () {
  try {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } catch (error) {
    try {
      let target;
      target = document.getElementById("anchor-main-app");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        target = document.getElementById("anchor-main-content");
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      }
    } catch (error) {
      return false;
    }
  }
  return true;
};

export const scrollTopDone = function () {
  return new Promise((resolve) => {
    scrollSnapTop();
    let iterator = 0;

    const checkIfDone = () => {
      iterator++;
      if (iterator > 50) {
        resolve();
        return;
      }
      if (window.scrollY === 0) {
        resolve();
      } else {
        requestAnimationFrame(checkIfDone);
      }
    };

    requestAnimationFrame(checkIfDone);
  });
};

export const scrollIntoViewIfNeeded = function (target, snap) {
  if (target.getBoundingClientRect().top < 0) {
    target.scrollIntoView({
      behavior: snap ? "instant" : "smooth",
      block: "start",
    });
  }
};

export const scrollToId = function (id, style) {
  let target = document.getElementById(id);
  if (target) {
    switch (style) {
      case "instant":
        target.scrollIntoView({ behavior: "instant", block: "start" });
        break;
      case "smooth":
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        break;
      default:
        scrollIntoViewIfNeeded(target);
        break;
    }
  }
};

export async function copyToClipboard(text) {
  if ("clipboard" in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    return document.execCommand("copy", true, text);
  }
}

export const closeAction = (
  mainContext,
  eventContext,
  closeTarget,
  menuSelectById,
) => {
  let menuId = closeTarget ? closeTarget : "home";
  menuSelectById(menuId);
  if (mainContext) {
    mainContext.updateViewerTrail({
      memberTab: 0,
      launchpadTab: 0,
    });
    mainContext.selectMenu(menuId);
  }
};

export const timeout = async (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
